// @flow
import React from 'react';
import { connect } from 'react-redux';

import getMatchData from '../modules/selectors/getMatchData';
import * as actions from '../modules/actions';

type Props = {
	fetchPlayers: typeof actions.players.fetchPlayers,
	fetchRounds: typeof actions.rounds.fetchRounds,
	fetchSquads: typeof actions.squads.fetchSquads,
	fetchVenues: typeof actions.venues.fetchVenues,
	match_data: Object
}

class MatchCentrePage extends React.Component<Props> {
	componentDidMount() {
		const { fetchVenues, fetchSquads, fetchRounds, fetchPlayers } = this.props;
		fetchPlayers();
		fetchRounds();
		fetchSquads();
		fetchVenues();
	}

	render() {
		return (
			<div>
				<h1>Match Centre</h1>
				<table>
					<tbody>
						<tr>
							<th>
								First Name
							</th>
							<th>
								Surname
							</th>
							<th>
								Squad
							</th>
							<th>
								Points
							</th>
						</tr>
						{this.props.match_data.players.map(player => (
							<tr key={player.ids}>
								<td>
									{player.first_name}
								</td>
								<td>
									{player.last_name}
								</td>
								<td>
									{player.squad.full_name}
								</td>
								<td>
									{player.stats.scores[this.props.match_data.match.round]}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);
	}
}

const mapStateToProps = (state, props) => ({
	match_data: getMatchData(state, props)
});

const mapDispatchToProps = {
	fetchPlayers: actions.players.fetchPlayers,
	fetchRounds: actions.rounds.fetchRounds,
	fetchSquads: actions.squads.fetchSquads,
	fetchVenues: actions.venues.fetchVenues,
};

export const MatchCentre = connect(
	mapStateToProps,
	mapDispatchToProps
)(MatchCentrePage);

export default MatchCentre;


// WEBPACK FOOTER //
// ./src/pages/MatchCentre.js